"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clone = void 0;
const rfdc_1 = __importDefault(require("rfdc"));
exports.clone = (0, rfdc_1.default)({
    proto: false,
    circles: false,
});
/*
// When the rfdc PR#31 is merged an released
export const clone = rfdc({
  proto: false,
  circles: false,
});
*/
